module.exports = __webpack_public_path__ + "media/bootstrap-icons/stoplights-6708396a.svg";